module.exports = __webpack_public_path__ + "static/media/4.7c5c9315.png";